<script setup lang="ts">
import { ParagraphTimeline, ParagraphTimelineItem } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTimeline
}>()

const items = computed(() => {
  const list = props.entity.fieldItems || []
  return list.map((item) => item && item.entity).filter(Boolean) as ParagraphTimelineItem[]
})

const isModalOpen = ref(false)
const selectedEntity = ref()
const currentMediaUrl = ref('')
const { controller } = useModalVideo(currentMediaUrl.value)

const fieldClicked = (value: { entity: ParagraphTimelineItem }) => {
  selectedEntity.value = value.entity
  isModalOpen.value = true
}
const mediaFieldClicked = (value: string) => {
  currentMediaUrl.value = value
  controller.open()
}
</script>

<template>
  <Section large>
    <ul class="items cul">
      <li v-for="(item, index) in items" :key="index" class="item">
        <TimelineFieldItem
          :entity="item"
          :counter="index + 1"
          @clicked="fieldClicked"
          @clicked-media="mediaFieldClicked"
        />
      </li>
    </ul>
    <ModalEmpty v-model:open="isModalOpen">
      <TimelineModalContent :entity="selectedEntity" />
    </ModalEmpty>
    <ModalVideo :controller="controller">
      <iframe v-if="currentMediaUrl" :src="currentMediaUrl" frameborder="0" allowfullscreen />
    </ModalVideo>
  </Section>
</template>

<style scoped lang="scss">
.item {
  &:nth-child(even) {
    .timeline-fielditem-container {
      flex-direction: column;
      align-items: center;
      @include breakpoint(tl) {
        flex-direction: row-reverse;
        text-align: end;
        align-items: flex-start;
      }
    }
  }
  &:nth-child(odd) {
    .timeline-fielditem-container {
      flex-direction: column;
      align-items: center;
      @include breakpoint(tl) {
        flex-direction: row;
        align-items: flex-start;
      }
    }
  }

  &:last-child {
    .timeline-fielditem-container {
      &::after {
        height: 80px;
      }
    }
  }
}
</style>
